export default function formattedDate(date: string | Date): string {
    return new Date(date).toLocaleDateString("uk-UA", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
}
